/* ==================================================
  c_staff-session.js — 客注モード（スタッフ）セッション storage（cookie）
  唯一の読み書き口（DRY）。window.CStaffSession を公開。
  cookie を使う理由: cross-tab で共有 + ブラウザを閉じると自動消去（spec §2.2.3 / §2.1.5）。
  HttpOnly は不可（App Proxy が Set-Cookie を除去 + JS が X-Staff-Mode-Token 送信のため token を読む必要）。
  session cookie（Max-Age/Expires なし）= ブラウザを閉じると消える。server TTL 1h が backstop（spec §1.8.2）。
  Host-only（Domain 未指定）; Secure（theme dev は https のため OK。純 http localhost では set 不可）。
  ===================================================*/
(function () {
  'use strict';
  var ATTRS = '; Path=/; Secure; SameSite=Strict';

  function read(name) {
    var m = document.cookie.match(new RegExp('(?:^|;\\s*)' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : '';
  }

  window.CStaffSession = {
    getToken: function () { try { return read('staff_mode_token'); } catch (e) { return ''; } },
    setToken: function (t) { try { document.cookie = 'staff_mode_token=' + encodeURIComponent(t) + ATTRS; } catch (e) {} },
    getStoreContext: function () {
      try {
        var parsed = JSON.parse(read('staff_mode_store_context') || '{}');
        return (parsed && typeof parsed === 'object') ? parsed : {};
      } catch (e) {
        console.warn('[c_staff-session] invalid stored store context', e);
        return {};
      }
    },
    setStoreContext: function (ctx) { try { document.cookie = 'staff_mode_store_context=' + encodeURIComponent(JSON.stringify(ctx)) + ATTRS; } catch (e) {} },
    // Dirty flag for the header bar latch (spec §2.1.7). UI-only state — never an order/cart attr.
    getNeedsClear: function () { try { return read('staff_mode_needs_clear') === '1'; } catch (e) { return false; } },
    setNeedsClear: function () { try { document.cookie = 'staff_mode_needs_clear=1' + ATTRS; } catch (e) {} },
    clearNeedsClear: function () { try { document.cookie = 'staff_mode_needs_clear=' + ATTRS + '; Max-Age=0'; } catch (e) {} },
    clear: function () {
      try {
        document.cookie = 'staff_mode_token=' + ATTRS + '; Max-Age=0';
        document.cookie = 'staff_mode_store_context=' + ATTRS + '; Max-Age=0';
        document.cookie = 'staff_mode_needs_clear=' + ATTRS + '; Max-Age=0';
      } catch (e) {}
    }
  };
})();
